import { media, TertiaryButton, Tile } from 'ia-react-core';
import styled from 'styled-components';

export const StyledTile = styled(Tile)`
  margin-top: 16px;

  ${media.lg`
    margin-top: 0;
  `}
`;

export const StyledDiv = styled.div`
    > section {
    margin-top: 5px;
    margin-bottom: 5px;
    border-top: 1px solid ${({ theme }) => theme.colors.gray3};
    padding-bottom: 24px;
    padding-top: 24px;
    display: block;
    align-items:center;

  ${media.sm`
    display: flex;
  `}
    :first-child{
      border-top: inherit;
      padding-top: 0;
      padding-bottom: 18px;
    }
    :last-child{
      padding-bottom: 0;
      margin-bottom: 0;
    }

  }
`;
export const StyledButton = styled(TertiaryButton)`
  margin-left: auto;
  margin-top: 14px;

  ${media.sm`
    margin-bottom: 4px;
    margin-top: 0;
  `}
`;
